import sensors from './autoTrack';
import './autoTrack'
// 判断页面初始化埋点的时候，是否做过默认授权
// ******注意：⚠️授权时考虑第三方链接是否需要授权获取openid
(function () {
// 注册公共属性
    sensors.registerPage({
        platform_type: 'PC',
        AppName: 'merchant'
    })
})()
